import React from "react";
import MainState from "./context/MainContext/MainState";
import SalesOrderContainer from "./components/SalesOrderContainer";
import "./SalesOrder.css"

const App = ()=>{
  return (  
    <MainState>
      <SalesOrderContainer/>
    </MainState>
  )
}

export default App;